import Vue from "vue";
import Vuex from "vuex";

import alerts from "./modules/alerts";
import auth from "./modules/auth";
import me from "./modules/me";
import options from "./modules/options";
import engineers from "./modules/engineers";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    alerts,
    auth,
    me,
    options,
    engineers
  }
});
